import { ComponentStyleConfig, SystemStyleObject } from '@chakra-ui/react';
import { StyleFunctionProps } from '@chakra-ui/theme-tools';

import {
  baseStyle as inputBaseStyle,
  variants as inputVariants,
  sizes as inputSizes
} from '../../molecules/Input/InputTheme';

export const variants = {
  basic: (props: StyleFunctionProps): SystemStyleObject => inputVariants.basic(props).field ?? {},
  outline: (props: StyleFunctionProps): SystemStyleObject => inputVariants.outline(props).field ?? {},
  filled: (props: StyleFunctionProps): SystemStyleObject => inputVariants.filled(props).field ?? {},
  unstyled: (props: StyleFunctionProps): SystemStyleObject => inputVariants.unstyled(props).field ?? {}
};

const getFieldValuesFrom = (cssObj: SystemStyleObject): Partial<SystemStyleObject> => ({
  fontSize: cssObj.fontSize,
  borderRadius: cssObj.borderRadius,
  paddingInlineStart: cssObj.scrollPaddingInlineStart,
  paddingInlineEnd: cssObj.paddingInlineEnd
});

export const sizes: Record<string, SystemStyleObject> = {
  xs: {
    ...getFieldValuesFrom(inputSizes.xs.field),
    lineHeight: '24px',
    py: '4px'
  },
  sm: {
    ...getFieldValuesFrom(inputSizes.sm.field),
    lineHeight: '28px',
    py: '4px'
  },
  md: {
    ...getFieldValuesFrom(inputSizes.md.field),
    fontSize: '17px',
    lineHeight: '30px',
    py: '6px'
  },
  lg: {
    ...getFieldValuesFrom(inputSizes.lg.field),
    fontSize: '20px',
    lineHeight: '30px',
    borderRadius: '8px',
    py: '8px'
  }
};

const TextareaTheme: ComponentStyleConfig = {
  baseStyle: (props: StyleFunctionProps) => ({
    ...inputBaseStyle(props).field
  }),
  variants,
  sizes,
  defaultProps: {
    colorScheme: undefined
  }
};

export default TextareaTheme;
